export default function Title(props){
  return <> 
    <div className={`title ${props.mainClass}`}>
      { props.serial && <div className="srtitle" >{props.serial} </div>} 
      { props.subclass ? <>
        <div className={`subtitle ${props.subclass}`} > 
          <h3>{props.subheading}</h3>
        </div>
        </>  
      : null}
      { props.title && <h2 className={`heading ${props.titleclass}`} >{props.title}</h2>  }
      {props.des && <p className={`des ${props.desclass}`} >{props.des}</p> }
    </div>
  </>
}
